import {
  PodporovateliaApi,
  PodporovatelListPage as PodporovatelListPageGenerated,
  Podporovatel as PodporovatelGenerated, PodporovatelApi,
} from 'pripomienky-web-ts-axios';
import { AxiosRequestConfig } from 'axios';
import { ClientResponse } from '../model/ClientResponse';
import PodporovatelListPage from '../model/podporovatel/PodporovatelListPage';
import apiConfiguration from './configuration/apiConfiguration';
import Podporovatel from '../model/podporovatel/Podporovatel';
import Uuid from '../model/Uuid';
import { pripomienkyPrefixPath } from './configuration/apiConfigurationConstants';

const client = new PodporovateliaApi(apiConfiguration(pripomienkyPrefixPath));
const podporovatelClient = new PodporovatelApi(apiConfiguration(pripomienkyPrefixPath));

const mapPodporovatel = (generated: PodporovatelGenerated): Podporovatel => ({
  uuid: generated.uuid,
  name: generated.name,
  organizacia: generated.organizacia,
  email: generated.email,
  datumPodporenia: generated.datum === null ? null : new Date(generated.datum),
});

const map = (generated: PodporovatelListPageGenerated): PodporovatelListPage => ({
  podporovatelia: generated.podporovatelList.map(podporovatel => mapPodporovatel(podporovatel)),
  totalElements: generated.totalElements,
  number: generated.number,
  size: generated.size,
});

export const fetchPodporovatelListPage = async (
  type: string,
  year: number,
  index: number,
  uuid: string,
  page?: number,
  options?: AxiosRequestConfig,
): Promise<ClientResponse<PodporovatelListPage>> => {
  const {
    data, status,
  } = await client.getPodporovateliaList(type, year, index, uuid, page, options);
  return {
    data: map(data), responseCode: status,
  };
};

export const addPodporovatel = async (
  type: string,
  year: number,
  index: number,
  uuid: Uuid,
  options?: AxiosRequestConfig,
)
  : Promise<ClientResponse<void>> => {
  const { data, status } = await podporovatelClient.addPodporovatel(type, year, index, uuid, options);

  return { data, responseCode: status };
};

export const removePodporovatel = async (
  type: string,
  year: number,
  index: number,
  uuid: Uuid,
  options?: AxiosRequestConfig,
)
  : Promise<ClientResponse<void>> => {
  const { data, status } = await podporovatelClient.removePodporovatel(type, year, index, uuid, options);

  return { data, responseCode: status };
};
